exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-grid[data-v-2b30ffd6]{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));column-gap:40px;max-width:1040px}.form-grid[data-v-2b30ffd6] .el-form-item__content>.el-input{max-width:none}@media (max-width:900px){.form-grid[data-v-2b30ffd6]{grid-template-columns:minmax(0,1fr)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b30ffd6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/locations/OwnerInformation.vue
// module id = 613
// module chunks = 0